// src/i18n/locales/de/referral.ts

const referral = {
  tab: 'Empfehlungsprogramm',

  title: 'Freunde einladen & Prämien verdienen',
  subtitle: 'Teile deinen persönlichen Link. Für jeden Freund, der ein Abo abschließt, erhältst du CHF 5 Guthaben.',

  yourLink: {
    title: 'Dein Empfehlungslink',
    description: 'Freunde, die sich über deinen Link registrieren, erhalten 10% Rabatt auf den ersten Monat.',
    copy: 'Link kopieren',
    copied: 'Kopiert!',
    generating: 'Dein Empfehlungscode wird gerade erstellt. Bitte aktualisiere die Seite in einem Moment.',
    code: 'Dein Code:'
  },

  rewards: {
    title: 'Deine Prämien',
    credit: 'CHF-Guthaben',
    creditDescription: 'Wird auf deiner nächsten Rechnung angerechnet',
    totalReferrals: 'Erfolgreiche Empfehlungen',
  },

  howItWorks: {
    title: 'So funktioniert es',
    step1Title: 'Link teilen',
    step1Text: 'Kopiere deinen persönlichen Link und teile ihn mit Freunden per Nachricht, E-Mail oder Social Media.',
    step2Title: 'Freund abonniert',
    step2Text: 'Dein Freund registriert sich und aktiviert ein bezahltes Abo. Er erhält 10% Rabatt auf den ersten Monat.',
    step3Title: 'Du wirst belohnt',
    step3Text: 'Sobald die Zahlung bestätigt ist, erhältst du automatisch CHF 5 Guthaben auf deinem Konto.',
  },

  history: {
    title: 'Empfehlungsverlauf',
    empty: 'Noch keine erfolgreichen Empfehlungen.',
    emptyHint: 'Teile deinen Link, um loszulegen!',
    friend: 'Freund',
    reward: 'Prämie',
    date: 'Datum',
    creditLabel: 'CHF {{value}} Guthaben',
  },
};

export default referral;